<div class="w-100">
    <mwp-card-content-header [url]="apiUrl" />
    <mwp-member-benefits />
</div>